"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modalSimple = _interopRequireDefault(require("./modal-simple"));

var _LinearProgress = _interopRequireDefault(require("@eig-builder/core-ui/LinearProgress"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@eig-builder/core-ui/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  height: 80px;\n  z-index: -1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  text-align: center;\n\n  img {\n    padding: ", ";\n    display: flex;\n    align-self: center;\n    width: 200px;\n    margin-top: -34px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledLoader = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      left: '0'
    }
  };
})(_LinearProgress.default);

var ModalContentWrapper = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.spacing(0, 5, 5);
});

var Backface = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.palette.lightGray.main;
});

var ModalWithBackface = function ModalWithBackface(_ref) {
  var open = _ref.open,
      image = _ref.image,
      loading = _ref.loading,
      onClose = _ref.onClose,
      children = _ref.children,
      actions = _ref.actions,
      height = _ref.height,
      maxWidth = _ref.maxWidth;
  return _react.default.createElement(_modalSimple.default, {
    title: "",
    open: open,
    maxWidth: maxWidth,
    height: height,
    onClose: onClose,
    actions: actions
  }, _react.default.createElement(ModalContentWrapper, null, _react.default.createElement(Backface, null), _react.default.createElement("img", {
    src: image
  }), children), loading && _react.default.createElement(StyledLoader, null));
};

ModalWithBackface.propTypes = {
  image: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired,
  actions: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]).isRequired,
  open: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  height: _propTypes.default.string,
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
};
ModalWithBackface.defaultProps = {
  loading: false,
  height: '440px',
  maxWidth: 'xs',
  open: false
};
var _default = ModalWithBackface;
exports.default = _default;